module.exports = __webpack_public_path__ + "img/logo_labhoh.01071e0e.svg";